var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HOME_ENVIROTAINER",
    transform: "matrix(1.1,0,0,1.1,-95,-95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M319.1,206.3L155.6,341.1c0,0.2,0,0.5-0.1,0.9c-0.1,0.4-0.1,0.6-0.1,0.9v136.5c0,4.9,1.8,9.2,5.4,12.8 c3.6,3.6,7.9,5.4,12.8,5.4h109.2V388.2h72.8v109.2h109.2c4.9,0,9.2-1.8,12.8-5.4c3.6-3.6,5.4-7.9,5.4-12.8V342.8 c0-0.8-0.1-1.3-0.3-1.7L319.1,206.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M548.2,316.4c-0.2-2.6-1.2-4.6-3.1-6.1l-62.3-51.7v-116c0-2.7-0.9-4.8-2.6-6.5c-1.7-1.7-3.9-2.6-6.5-2.6 h-54.6c-2.7,0-4.8,0.9-6.5,2.6c-1.7,1.7-2.6,3.9-2.6,6.5v55.4l-69.4-58c-6.1-4.9-13.3-7.4-21.6-7.4c-8.3,0-15.5,2.5-21.6,7.4 L93.1,310.3c-1.9,1.5-2.9,3.5-3.1,6.1c-0.2,2.6,0.5,4.8,2,6.7l17.6,21c1.5,1.7,3.5,2.8,6,3.1c2.3,0.2,4.6-0.5,6.8-2l196.7-164 l196.7,164c1.5,1.3,3.5,2,6,2h0.9c2.5-0.4,4.4-1.4,6-3.1l17.6-21C547.7,321.2,548.4,319,548.2,316.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.11f7e1468f26da3c1f53bb46b0c00355.svg";
export { ForwardRef as ReactComponent };